import { CHANNELS } from "../../../mocks/newsData";

const NAV = [
  { href: "#focus", label: "焦点速递" },
  { href: "#live", label: "实时滚动" },
  { href: "#rank", label: "热搜排行" },
  { href: "#depth", label: "深度追踪" },
  { href: "#faq", label: "热点问答" },
  { href: "#about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="border-t-4 border-primary-500 bg-gradient-to-b from-background-200 to-background-300">
      <div className="mx-auto max-w-[1440px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
                爆
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-xl font-black leading-none text-foreground-950">实时爆料</span>
                <span className="mt-1 font-label text-[10px] uppercase tracking-[0.25em] text-foreground-500">
                  Real-time News Desk
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              今日热点滚动更新 · 全网资讯第一时间聚合与深度追踪。以分钟为单位跟进大事进展，把“刚刚发生”原原本本带给你。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["真实", "及时", "客观", "可持续"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-foreground-200 bg-background-50/60 px-3 py-1 text-xs font-medium text-foreground-600"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-bold text-foreground-950">站内导航</h4>
            <ul className="mt-3 grid grid-cols-2 gap-x-2 gap-y-2">
              {NAV.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-bold text-foreground-950">热点栏目</h4>
            <ul className="mt-3 grid grid-cols-2 gap-x-2 gap-y-2">
              {CHANNELS.filter((c) => c.id !== "all").map((c) => (
                <li key={c.id}>
                  <a
                    href="#focus"
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {c.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#contact"
                  className="whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  线索征集 →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-foreground-200/70 pt-5 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 实时爆料 · 专注今日热点滚动更新的资讯平台 · 本页内容由编辑部人工采编与交叉核验
          </p>
          <nav className="flex flex-wrap items-center gap-4" aria-label="页脚辅助导航">
            <a href="#about" className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600">
              关于我们
            </a>
            <a href="#faq" className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600">
              常见问题
            </a>
            <a href="#contact" className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600">
              联系编辑部
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}